import React, { useCallback } from 'react';

import { Form, Input } from 'antd';

import { useFormikContext } from 'formik';
import { Hint } from 'v2/components/Shared/Hint';
import moneyNoSymbolMask from 'v2/components/Shared/Masks/moneyNoSymbol';

type CurrencyFormFieldProps = {
  [key: string]: any;
  id?: string;
  name?: string;
  helperText?: React.ReactNode;
  currency?: string;
  prefix?: React.ReactNode;
  InputProps?: any;
  inputProps?: any;
};

const CurrencyFormField = ({
  helperText,
  name,
  currency = 'BRL',
  prefix,
  InputProps,
  inputProps,
  ...props
}: CurrencyFormFieldProps) => {
  const { getFieldMeta, setFieldValue, setFieldTouched } = useFormikContext();
  const meta = getFieldMeta<number>(name);
  const errorText = meta.touched && meta.error;
  const maskedValue = moneyNoSymbolMask.apply(meta.value, currency);

  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      return setFieldValue(name, moneyNoSymbolMask.clean(e.target.value, currency));
    },
    [setFieldValue, name, currency]
  );

  const onBlurHandler = useCallback(() => {
    setFieldTouched(name, true);
  }, [setFieldTouched, name]);

  const addonPrefix = prefix || InputProps?.startAdornment?.props?.children;

  return (
    <Hint inputName={name}>
      <Form.Item
        className='mb-0 w-full'
        help={errorText || helperText}
        validateStatus={errorText ? 'error' : undefined}
      >
        <Input
          id={props.id}
          prefix={addonPrefix}
          status={errorText ? 'error' : undefined}
          name={name}
          value={maskedValue}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
          {...inputProps}
          className={['w-full max-w-55', inputProps?.className].filter(Boolean).join(' ')}
        />
      </Form.Item>
    </Hint>
  );
};

export default CurrencyFormField;
